var cilSignalCellular4 = ["512 512", "<path fill='var(--ci-primary-color, currentColor)' d='M384.78,88h-.1v.1L208.78,264h-.1v.1L16,456.78V496H496V16H456.78Zm-264.1,376H54.034l66.647-66.646Zm88,0h-56V365.354l56-56Zm88,0h-56V277.354l56-56Zm88,0h-56V189.354l56-56ZM464,464H416.681V101.354L464,54.034Z' class='ci-primary'/>"];

export { cilSignalCellular4 };

